import { render, staticRenderFns } from "./TabelaAcoes.vue?vue&type=template&id=069e2c0d&"
import script from "./TabelaAcoes.vue?vue&type=script&lang=js&"
export * from "./TabelaAcoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports